'use client'

import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'
import { Star } from 'lucide-react'
import 'swiper/css'
import 'swiper/css/navigation'
import { HttpService, ServiceEndpoints, Common } from '@/config/NextImport'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import GoogleReviewsSkeleton from './GoogleReviewsSkeleton';
interface GoogleReview {
  profile_photo_url: string
  author_name: string
  rating: number
  text: string
  relative_time_description: string
}

const Review = [
  {
    author_name: 'Alexander Miller',
    author_url: 'https://www.google.com/maps/contrib/107100153809297594901/reviews',
    language: 'en',
    original_language: 'en',
    profile_photo_url:
      'https://lh3.googleusercontent.com/a/ACg8ocIZ-aW7dUoMcrgy8i6ay7Qf2wkjoq4VMspOhfYMTWIx1CoP=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    relative_time_description: '2 months ago',
    text: 'We actually found Harmony through my partner looking for ring ideas on Tik Tok and fell in love instantly! We had the BEST experience with Harmony Jewels, couldn’t fault a thing. Myself and my partner both went to the store to spec the engagement ring as I knew she was clear what she wanted and might as well get it exactly so! We were served by Antea and she was so smiley and welcoming and so happy to be a part of our initial speccing session. As we had no experience around jewellery at all she took us from top to bottom of the speccing a ring, every single element she explained perfectly, and help us build the perfect ring for my partner. They offered everything, and I mean everything! Totally custom including the options for both lab grown and earth mined to all the cuts and colours. The session felt so personal and we came away grinning from ear to ear!! I ordered the ring about 5/6 months later and went back to the store to collect it. Antea served me again and we’d been dealing directly with each other throughout the process, so it was nice to close the loop from start to end. All in all I couldn’t fault the process and the ring turned out perfectly and most importantly she said YES!! Antea asked if I could send her pictures afterwards as she wanted to see, so I did! We got some really lovely messages from Harmony congratulating us on our engagement, which was so sweet too and a lovely touch!',
    time: 1759651027,
    translated: false
  },
  {
    author_name: 'Vicky Foxwell',
    author_url: 'https://www.google.com/maps/contrib/103820504203681355163/reviews',
    language: 'en',
    original_language: 'en',
    profile_photo_url:
      'https://lh3.googleusercontent.com/a/ACg8ocJ6r1mw5EDa57RFDHbAs7pe1rL2SgWjbxNhnDZIKszCO94HRg=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    relative_time_description: '3 months ago',
    text: 'Can’t express enough how amazing harmony Jewels and more specifically Rania was for my experience. I got my fiancé her ring from harmony jewels and they brought exactly what I wanted to life to create our magical moment - the ring is absolutely stunning & can’t recommend them enough. We have been following harmony jewels for years and they never failed to interact with our posts/stories on Instagram which further confirmed my decision to go get my ring through them!',
    time: 1759344337,
    translated: false
  },
  {
    author_name: 'F P',
    author_url: 'https://www.google.com/maps/contrib/103634358302683720562/reviews',
    language: 'en',
    original_language: 'en',
    profile_photo_url:
      'https://lh3.googleusercontent.com/a/ACg8ocK763k8fryk47K7qSJxDSF60QvvGfbgvKrv5AgRnjmTD1qbmQ=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    relative_time_description: '3 months ago',
    text: 'Harmony Jewels was recommended to us by a friend; it was the first jeweller we went to and we left with our perfect engagement ring! We were served by Rania, who was warm, friendly, helpful and patient. We had booked our appointment in advance with a description of our ring preferences and budget, and Rania had already prepared several great options for us to look at when we arrived (a variety of settings with different prong and metal options). Rania provided customisation and met all of our requirements within our budget. She gave excellent advice and sized the ring perfectly. Rania also took time to explain the grading system for diamonds. The setting is custom designed to the size / shape of the diamond, which we were also able to look at separately in different lighting. We picked up our ring a few weeks later and I have had so many compliments on it! The ring was also beautifully packaged, and came with a diamond certificate. Harmony Jewels have a variety of natural and lab grown diamonds and a variety of setting styles. They also offer a bespoke and individual service, with competitive pricing and excellent quality. We will definitely be coming back for our wedding bands!  Thank you so very much to Rania - you were wonderful.',
    time: 1758654878,
    translated: false
  },
  {
    author_name: 'Dan',
    author_url: 'https://www.google.com/maps/contrib/100616770675009705089/reviews',
    language: 'en',
    original_language: 'en',
    profile_photo_url:
      'https://lh3.googleusercontent.com/a/ACg8ocL9qzFPHJ3KrMHZR7gPXaKQzXZlj9WeMPKrf2VkPz4f3TBSOg=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    relative_time_description: '2 months ago',
    text: 'I had a great experience with Harmony Jewels. Esra who helped me was absolutely amazing. She answered all my questions with patience…and never tried to upsell me. She genuinely wanted to help me find the perfect ring. I had several specific requests and even made small tweaks along the way, and Esra accommodated everything perfectly.\n\nThe final ring turned out even better than I imagined. My now-fiancé absolutely loves it.',
    time: 1762116208,
    translated: false
  },
  {
    author_name: 'Elliot Green',
    author_url: 'https://www.google.com/maps/contrib/111760546089440361338/reviews',
    language: 'en',
    original_language: 'en',
    profile_photo_url:
      'https://lh3.googleusercontent.com/a/ACg8ocILoa2tUyqZDRjLxJEylqKky_UGIfHKeROtqG5VyJgj9kUuxg=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    relative_time_description: '2 weeks ago',
    text: "I had an absolutely excellent experience with Harmony Jewels. From start to finish Rania handled everything with the utmost professionalism and care. Rania helped me design an engagement ring and was incredibly knowledgeable, attentive, and went above and beyond to ensure all my needs were met.\n\nThe process was seamless, and I felt supported every step of the way. Rania's attention to detail and commitment to delivering top-notch service truly stood out. I couldn’t be happier with the outcome and would highly recommend their services to anyone looking for a reliable and exceptional experience.\n\nThank you for exceeding my expectations!",
    time: 1765560416,
    translated: false
  }
]
export default function GoogleReviewsSwiper() {
  const [Reviews, setReviews] = useState<GoogleReview[]>([])
  const [totalReviews, setTotalReviews] = useState<number>(0)

  const environment = process.env.NEXT_PUBLIC_NODE_ENV
  useEffect(() => {
    if (environment === 'development' || environment === 'staging') {
      // Use static reviews
      setReviews(Review)
      setTotalReviews(Review.length)
    } else {
      // setReviews(Review)
      // setTotalReviews(Review.length)
      // Production → API
      fetchReviews()
    }
  }, [])
  const fetchReviews = async () => {
    HttpService.postApi(ServiceEndpoints.getGoogleReviews, null).then((response: any) => {
      try {
        if (response.result.error_message) {
          return
        }
        if (response.result) {
          setReviews(response.result.result.reviews)
          setTotalReviews(response.result.result.user_ratings_total)
        }
      } catch (err) {
        console.log(err)
      }
    })
  }

  function ReadMore({ text, limit = 215 }: { text: string; limit?: number }) {
    const [open, setOpen] = useState(false)

    if (text.length <= limit) {
      return <p className="small text-muted mb-0">{text}</p>
    }

    return (
      <p className="small text-muted mb-0">
        {open ? text : text.slice(0, limit) + '...'}
        <span
          onClick={() => setOpen(!open)}
          className="mt-2 fw-semibold d-block"
          style={{ color: '#c29cac', cursor: 'pointer' }}
        >
          {open ? 'Read Less' : 'Read More'}
        </span>
      </p>
    )
  }

  return (
    <>
      {Reviews.length === 0 ? (
        <GoogleReviewsSkeleton />
      ) : (
        <section className="container-fluid pt-5 bg-white google-reviews-section">
          <div className="container">
            {/* Title */}
            {/* <div className="text-center mb-4">
              <h2 className="fw-semibold">A Tradition of Trust & Quality</h2>
              <p className="mt-3 max-width-800 mx-auto">
                Harmony Jewels stands for quality and craftsmanship in Hatton Garden, earning the
                confidence and appreciation of clients who share their experiences through glowing
                reviews.
              </p>
            </div> */}

            <div className="row align-items-center">
              {/* LEFT RATING COLUMN */}
              <div className="col-md-3 col-xl-2 mb-4 mb-lg-0 text-center text-lg-start px-0">
                <a
                  href="https://goo.gl/maps/DMPiYthseUfYeqjA7"
                  target="_blank"
                >
                  <h3 className="fw-bold mb-2">EXCELLENT</h3>

                  <div className="d-flex justify-content-center justify-content-lg-start mb-2"> 
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        size={20}
                        fill="#fbbc04"
                        stroke="none"
                      />
                    ))}
                  </div>

                  <p className="small text-muted mb-2">
                    Based on{' '}
                    <span className="fw-bold">
                      {totalReviews > 0 ? (
                        <span>{totalReviews}</span>
                      ) : (
                        <Skeleton
                          highlightColor={'#f1ebee'}
                          width={35}
                          height={16}
                          baseColor={'#f1f1f1'}
                          inline={true}
                        />
                      )}{' '}
                      reviews
                    </span>
                  </p>
                  <svg
                    version="1.1"
                    viewBox="0 0 255.2 80.3"
                    width={100}
                    height={32}
                  >
                    <g>
                      <path
                        fill="#4285F4"
                        d="M31.9,28.6v8.6h20.5c-0.6,4.8-2.2,8.3-4.7,10.8c-3,3-7.7,6.3-15.8,6.3	c-12.6,0-22.5-10.2-22.5-22.8S19.2,8.6,31.9,8.6c6.8,0,11.8,2.7,15.5,6.1l6-6C48.3,3.8,41.4,0,31.9,0C14.6,0,0,14.1,0,31.4	s14.6,31.4,31.9,31.4c9.4,0,16.4-3.1,21.9-8.8c5.7-5.7,7.4-13.6,7.4-20.1c0-2-0.1-3.8-0.5-5.4H31.9z"
                      />
                      <path
                        fill="#EA4335"
                        d="M86.9,21.6c-11.2,0-20.4,8.5-20.4,20.3c0,11.7,9.1,20.3,20.4,20.3s20.4-8.6,20.4-20.3	C107.2,30.1,98.1,21.6,86.9,21.6z M86.9,54.2c-6.1,0-11.4-5.1-11.4-12.3c0-7.3,5.3-12.3,11.4-12.3c6.1,0,11.4,5,11.4,12.3	C98.3,49.1,93,54.2,86.9,54.2z"
                      />
                      <path
                        fill="#4285F4"
                        d="M186.6,26.1h-0.3c-2-2.4-5.8-4.5-10.7-4.5c-10.1,0-19,8.8-19,20.3c0,11.4,8.8,20.3,19,20.3	c4.9,0,8.7-2.2,10.7-4.6h0.3v2.8c0,7.7-4.2,11.9-10.8,11.9c-5.4,0-8.8-3.9-10.2-7.2l-7.7,3.2c2.2,5.4,8.1,12,18,12	c10.4,0,19.3-6.1,19.3-21.1V22.7h-8.4V26.1z M176.4,54.2c-6.1,0-10.8-5.2-10.8-12.3c0-7.2,4.7-12.3,10.8-12.3	c6.1,0,10.8,5.2,10.8,12.4C187.3,49,182.5,54.2,176.4,54.2z"
                      />
                      <path
                        fill="#FBBC05"
                        d="M132.3,21.6c-11.2,0-20.4,8.5-20.4,20.3c0,11.7,9.1,20.3,20.4,20.3s20.4-8.6,20.4-20.3	C152.6,30.1,143.5,21.6,132.3,21.6z M132.3,54.2c-6.1,0-11.4-5.1-11.4-12.3c0-7.3,5.3-12.3,11.4-12.3c6.1,0,11.4,5,11.4,12.3	C143.7,49.1,138.4,54.2,132.3,54.2z"
                      />
                      <path
                        fill="#34A853"
                        d="M202.1,0.8h8.8v61.3h-8.8V0.8z"
                      />
                      <path
                        fill="#EA4335"
                        d="M237.9,54.2c-4.5,0-7.7-2.1-9.8-6.1l27.1-11.2l-0.9-2.3c-1.7-4.5-6.8-12.9-17.3-12.9	c-10.4,0-19.1,8.2-19.1,20.3c0,11.4,8.6,20.3,20.1,20.3c9.3,0,14.7-5.7,16.9-9l-6.9-4.6C245.6,51.9,242.4,54.2,237.9,54.2	L237.9,54.2z M237.3,29.2c3.6,0,6.7,1.9,7.7,4.5l-18.3,7.6C226.6,32.7,232.7,29.2,237.3,29.2z"
                      />
                    </g>
                  </svg>
                </a>
              </div>

              {/* RIGHT SWIPER */}
              <div className="col-md-9 col-xl-10 px-0 px-md-3">
                <Swiper
                  className="google-review-swiper"
                  modules={[Navigation, Autoplay]}
                  navigation
                  loop
                  spaceBetween={15}
                  slidesPerView={3}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 1 },
                    992: { slidesPerView: 2 },
                    1200: { slidesPerView: 3 }
                  }}
                >
                  {Reviews.map((item, i) => (
                    <SwiperSlide key={i}>
                      <div className="h-100 p-2 py-md-2 px-md-2 p-lg-2">
                        <div className="card h-100 border-0 shadow-sm rounded-4">
                          <div className="card-body d-flex flex-column p-3">
                            {/* Header */}
                            <div className="d-flex align-items-center mb-2">
                              <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                                <img
                                  className="review-profile-img"
                                  src={item.profile_photo_url}
                                  height="40"
                                  width="40"
                                  alt="profile"
                                />
                              </div>

                              <div className="flex-grow-1">
                                <div className="fw-semibold mb-1">{item.author_name}</div>
                                {/* Stars */}
                                <div className="d-flex mb-1 mt-1">
                                  {[...Array(item.rating)].map((_, j) => (
                                    <Star
                                      key={j}
                                      size={16}
                                      fill="#fbbc04"
                                      stroke="none"
                                    />
                                    // <span className="star-rating d-flex justify-content-center align-items-center p-1" style={{ backgroundColor: '#00B67A' }} key={j}>
                                    //   <Star
                                    //     size={14}
                                    //     fill="#fff"
                                    //     stroke="none"
                                    //   />
                                    // </span>
                                  ))}
                                </div>
                              </div>

                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 48 48"
                                width={22}
                                height={22}
                                className=""
                              >
                                <g>
                                  <path
                                    fill="#EA4335"
                                    d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                                  ></path>
                                  <path
                                    fill="#4285F4"
                                    d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                                  ></path>
                                  <path
                                    fill="#FBBC05"
                                    d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                                  ></path>
                                  <path
                                    fill="#34A853"
                                    d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                                  ></path>
                                  <path
                                    fill="none"
                                    d="M0 0h48v48H0z"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                            <div className="text-gray small mb-2">
                              {item.relative_time_description}
                            </div>
                            {/* Text */}
                            <div className="google-review-text">
                              <ReadMore
                                text={item.text}
                                limit={205}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}
